import React from 'react';
import { Helmet } from 'react-helmet';

const SEO = ({ 
  title, 
  description, 
  keywords, 
  image, 
  url, 
  type = 'website',
  structuredData = null 
}) => {
  const defaultTitle = "Car Key Perth - #1 Mobile Car Key Replacement Service";
  const defaultDescription = "Car key in Perth? Lost keys? Perth's #1 mobile car key replacement service. We come to you anywhere in Perth, Fremantle, Joondalup & WA. Professional service, all car brands.";
  const defaultKeywords = "car key in perth, car key replacement perth, mobile car key service perth, lost car keys perth, car key programming perth, smart key replacement perth, key fob replacement perth, transponder key perth, car key cutting perth, emergency car key service perth, car locksmith perth, fremantle car keys, joondalup car keys, rockingham car keys, canning vale car keys, scarborough car keys, mount lawley car keys, western australia car keys, professional car key service, car key warranty perth, car key perth, car key replacement perth wa, mobile car key perth, car key service perth, car key programming perth wa, car key cutting perth wa, car key fob perth, car key remote perth, car key transponder perth, car key emergency perth, car key locksmith perth, car key mobile perth, car key professional perth, car key warranty perth wa, car key all brands perth, car key toyota perth, car key honda perth, car key ford perth, car key bmw perth, car key audi perth, car key hyundai perth, car key kia perth, car key mazda perth, car key nissan perth, car key subaru perth, car key volkswagen perth, car key holden perth, car key jeep perth, car key lexus perth, car key infiniti perth, car key genesis perth, car key ferrari perth, car key maserati perth, car key lotus perth, car key abarth perth, car key skoda perth, car key chery perth, car key chevrolet perth, car key datsun perth, car key eicher perth, car key gmc perth, car key isuzu perth, car key jmc perth, car key mahindra perth, car key renault samsung perth, car key tata perth";
  const defaultImage = "https://carkeysolutionsperth.com.au/og-image.jpg";
  const defaultUrl = "https://carkeysolutionsperth.com.au";

  // Enhanced structured data for local business
  const defaultStructuredData = {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    "name": "Carkey Solutions Perth",
    "alternateName": "Car Key in Perth",
    "description": "Perth's #1 mobile car key replacement service. Professional car key programming, cutting, and replacement for all car brands in Perth, Western Australia.",
    "url": "https://carkeysolutionsperth.com.au",
    "telephone": "+61430168669",
    "email": "info@carkeysolutionsperth.com.au",
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "70 Division Street",
      "addressLocality": "Welshpool",
      "addressRegion": "Western Australia",
      "postalCode": "6106",
      "addressCountry": "AU"
    },
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": -31.9505,
      "longitude": 115.8605
    },
    "openingHours": "Mo-Su 00:00-23:59",
    "priceRange": "$$",
    "paymentAccepted": "Cash, Credit Card, Bank Transfer",
    "currenciesAccepted": "AUD",
    "areaServed": [
      {
        "@type": "City",
        "name": "Perth"
      },
      {
        "@type": "City", 
        "name": "Fremantle"
      },
      {
        "@type": "City",
        "name": "Joondalup"
      },
      {
        "@type": "City",
        "name": "Rockingham"
      },
      {
        "@type": "City",
        "name": "Canning Vale"
      },
      {
        "@type": "City",
        "name": "Scarborough"
      },
      {
        "@type": "City",
        "name": "Mount Lawley"
      }
    ],
    "serviceArea": {
      "@type": "GeoCircle",
      "geoMidpoint": {
        "@type": "GeoCoordinates",
        "latitude": -31.9505,
        "longitude": 115.8605
      },
      "geoRadius": "50000"
    },
    "hasOfferCatalog": {
      "@type": "OfferCatalog",
      "name": "Car Key Services",
      "itemListElement": [
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Car Key Replacement Perth",
            "description": "Professional car key replacement service for all car brands"
          }
        },
        {
          "@type": "Offer", 
          "itemOffered": {
            "@type": "Service",
            "name": "Smart Key Programming Perth",
            "description": "Advanced smart key and remote fob programming"
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service", 
            "name": "Transponder Key Programming Perth",
            "description": "Chip key cutting and programming for maximum security"
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Emergency Car Key Service Perth", 
            "description": "24/7 emergency car key replacement service"
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Mobile Car Key Service Perth",
            "description": "We come to your location anywhere in Perth"
          }
        }
      ]
    },
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "4.9",
      "reviewCount": "500",
      "bestRating": "5",
      "worstRating": "1"
    },
    "review": [
      {
        "@type": "Review",
        "reviewRating": {
          "@type": "Rating",
          "ratingValue": "5",
          "bestRating": "5"
        },
        "author": {
          "@type": "Person",
          "name": "John Smith"
        },
        "reviewBody": "Excellent car key replacement service in Perth. Fast, professional, and reliable."
      },
      {
        "@type": "Review", 
        "reviewRating": {
          "@type": "Rating",
          "ratingValue": "5",
          "bestRating": "5"
        },
        "author": {
          "@type": "Person",
          "name": "Sarah Johnson"
        },
        "reviewBody": "Best car key service in Perth. They came to my location and fixed my smart key quickly."
      }
    ],
    "sameAs": [
      "https://www.facebook.com/Carkeysolutions.net.au/?_rdr"
    ],
    "image": "https://carkeysolutionsperth.com.au/og-image.jpg",
    "logo": "https://carkeysolutionsperth.com.au/logo/LG.png"
  };

  const finalTitle = title || defaultTitle;
  const finalDescription = description || defaultDescription;
  const finalKeywords = keywords || defaultKeywords;
  const finalImage = image || defaultImage;
  const finalUrl = url || defaultUrl;
  const finalStructuredData = structuredData || defaultStructuredData;

  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{finalTitle}</title>
      <meta name="title" content={finalTitle} />
      <meta name="description" content={finalDescription} />
      <meta name="keywords" content={finalKeywords} />
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={finalUrl} />
      <meta property="og:title" content={finalTitle} />
      <meta property="og:description" content={finalDescription} />
      <meta property="og:image" content={finalImage} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:site_name" content="Carkey Solutions Perth" />
      <meta property="og:locale" content="en_AU" />
      
      {/* Twitter */}
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content={finalUrl} />
      <meta property="twitter:title" content={finalTitle} />
      <meta property="twitter:description" content={finalDescription} />
      <meta property="twitter:image" content={finalImage} />
      
      {/* Structured Data */}
      <script type="application/ld+json">
        {JSON.stringify(finalStructuredData)}
      </script>
      
      {/* Additional SEO Meta Tags */}
      <meta name="geo.region" content="AU-WA" />
      <meta name="geo.placename" content="Perth, Western Australia" />
      <meta name="geo.position" content="-31.9505;115.8605" />
      <meta name="ICBM" content="-31.9505, 115.8605" />
      <meta name="distribution" content="global" />
      <meta name="rating" content="general" />
      <meta name="revisit-after" content="7 days" />
      <meta name="language" content="English" />
      <meta name="coverage" content="Worldwide" />
      <meta name="target" content="all" />
      <meta name="HandheldFriendly" content="true" />
      <meta name="MobileOptimized" content="width" />
      <meta name="apple-mobile-web-app-capable" content="yes" />
      <meta name="apple-mobile-web-app-status-bar-style" content="black-translucent" />
      <meta name="apple-mobile-web-app-title" content="Carkey Solutions Perth" />
      <meta name="application-name" content="Carkey Solutions Perth" />
      <meta name="msapplication-TileColor" content="#dc2626" />
      
      {/* Preconnect to external domains for performance */}
      <link rel="preconnect" href="https://cdnjs.cloudflare.com" />
      <link rel="preconnect" href="https://fonts.googleapis.com" />
      <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="anonymous" />
      
      {/* Hreflang for international SEO */}
      <link rel="alternate" hreflang="en" href={finalUrl} />
      <link rel="alternate" hreflang="en-AU" href={finalUrl} />
      <link rel="alternate" hreflang="x-default" href={finalUrl} />
      
      {/* Social Media Links */}
      <meta property="og:see_also" content="https://www.facebook.com/Carkeysolutions.net.au/?_rdr" />
      
      {/* Business Information */}
      <meta name="business:contact_data:street_address" content="70 Division Street, Welshpool, Western Australia" />
      <meta name="business:contact_data:locality" content="Welshpool" />
      <meta name="business:contact_data:region" content="Western Australia" />
      <meta name="business:contact_data:postal_code" content="6106" />
      <meta name="business:contact_data:country_name" content="Australia" />
      <meta name="business:contact_data:phone_number" content="+61430168669" />
      
      {/* Service Areas */}
      <meta name="service_area:perth" content="Perth, Western Australia" />
      <meta name="service_area:fremantle" content="Fremantle, Western Australia" />
      <meta name="service_area:joondalup" content="Joondalup, Western Australia" />
      <meta name="service_area:rockingham" content="Rockingham, Western Australia" />
      <meta name="service_area:canning_vale" content="Canning Vale, Western Australia" />
      <meta name="service_area:scarborough" content="Scarborough, Western Australia" />
      <meta name="service_area:mount_lawley" content="Mount Lawley, Western Australia" />
      
      {/* Car Brands Supported */}
      <meta name="car_brands:toyota" content="Toyota Key Replacement Perth" />
      <meta name="car_brands:honda" content="Honda Key Replacement Perth" />
      <meta name="car_brands:ford" content="Ford Key Replacement Perth" />
      <meta name="car_brands:bmw" content="BMW Key Replacement Perth" />
      <meta name="car_brands:audi" content="Audi Key Replacement Perth" />
      <meta name="car_brands:hyundai" content="Hyundai Key Replacement Perth" />
      <meta name="car_brands:kia" content="Kia Key Replacement Perth" />
      <meta name="car_brands:mazda" content="Mazda Key Replacement Perth" />
      <meta name="car_brands:mitsubishi" content="Mitsubishi Key Replacement Perth" />
      <meta name="car_brands:nissan" content="Nissan Key Replacement Perth" />
      <meta name="car_brands:subaru" content="Subaru Key Replacement Perth" />
      <meta name="car_brands:volkswagen" content="Volkswagen Key Replacement Perth" />
      <meta name="car_brands:holden" content="Holden Key Replacement Perth" />
      <meta name="car_brands:jeep" content="Jeep Key Replacement Perth" />
      <meta name="car_brands:lexus" content="Lexus Key Replacement Perth" />
      <meta name="car_brands:infiniti" content="Infiniti Key Replacement Perth" />
      <meta name="car_brands:genesis" content="Genesis Key Replacement Perth" />
      <meta name="car_brands:ferrari" content="Ferrari Key Replacement Perth" />
      <meta name="car_brands:maserati" content="Maserati Key Replacement Perth" />
      <meta name="car_brands:lotus" content="Lotus Key Replacement Perth" />
      <meta name="car_brands:abarth" content="Abarth Key Replacement Perth" />
      <meta name="car_brands:skoda" content="Skoda Key Replacement Perth" />
      <meta name="car_brands:chery" content="Chery Key Replacement Perth" />
      <meta name="car_brands:chevrolet" content="Chevrolet Key Replacement Perth" />
      <meta name="car_brands:datsun" content="Datsun Key Replacement Perth" />
      <meta name="car_brands:eicher" content="Eicher Key Replacement Perth" />
      <meta name="car_brands:gmc" content="GMC Key Replacement Perth" />
      <meta name="car_brands:isuzu" content="Isuzu Key Replacement Perth" />
      <meta name="car_brands:jmc" content="JMC Key Replacement Perth" />
      <meta name="car_brands:mahindra" content="Mahindra Key Replacement Perth" />
      <meta name="car_brands:renault_samsung" content="Renault Samsung Key Replacement Perth" />
      <meta name="car_brands:tata" content="Tata Key Replacement Perth" />
      
      {/* Services Offered */}
      <meta name="services:lost_key_replacement" content="Lost Car Key Replacement Perth" />
      <meta name="services:spare_key_creation" content="Spare Car Key Creation Perth" />
      <meta name="services:smart_key_programming" content="Smart Key Programming Perth" />
      <meta name="services:keyless_entry_systems" content="Keyless Entry Systems Perth" />
      <meta name="services:transponder_key_programming" content="Transponder Key Programming Perth" />
      <meta name="services:emergency_service" content="Professional Car Key Service Perth" />
      <meta name="services:mobile_service" content="Mobile Car Key Service Perth" />
      <meta name="services:warranty" content="12-Month Car Key Warranty Perth" />
      
      {/* Emergency Contact */}
      <meta name="emergency_phone" content="+61430168669" />
      <meta name="whatsapp_contact" content="https://wa.me/61430168669" />
      <meta name="service_hours" content="Professional Service" />
      <meta name="response_time" content="15-30 minutes" />
      
      {/* Local SEO Keywords */}
      <meta name="local_keywords:perth" content="car key replacement perth, mobile car key service perth, car locksmith perth" />
      <meta name="local_keywords:fremantle" content="car key replacement fremantle, mobile car key service fremantle" />
      <meta name="local_keywords:joondalup" content="car key replacement joondalup, mobile car key service joondalup" />
      <meta name="local_keywords:rockingham" content="car key replacement rockingham, mobile car key service rockingham" />
      <meta name="local_keywords:canning_vale" content="car key replacement canning vale, mobile car key service canning vale" />
      <meta name="local_keywords:scarborough" content="car key replacement scarborough, mobile car key service scarborough" />
      <meta name="local_keywords:mount_lawley" content="car key replacement mount lawley, mobile car key service mount lawley" />
      
      {/* Business Hours and Availability */}
      <meta name="business_hours" content="Professional Service" />
      <meta name="availability" content="Available for professional car key service" />
      <meta name="mobile_service" content="We come to your location anywhere in Perth" />
      <meta name="warranty_info" content="12-month warranty on all car key services" />
      
      {/* Trust Signals */}
      <meta name="trust_signals:certified_technicians" content="Certified car key technicians" />
      <meta name="trust_signals:licensed_service" content="Licensed and insured car key service" />
      <meta name="trust_signals:customer_reviews" content="500+ happy Perth customers" />
      <meta name="trust_signals:years_experience" content="Years of experience in car key replacement" />
      <meta name="trust_signals:all_brands" content="All car brands supported" />
      <meta name="trust_signals:guaranteed_service" content="Guaranteed car key replacement service" />
      
    </Helmet>
  );
};

export default SEO;



